import { createAction } from "@reduxjs/toolkit";
import {
    FolderDto,
    NoteDto,
    ProjectDto,
    SaleActivityDto,
    SaleDto,
} from "../api/psc";

export const projectVisitedAction = createAction<string>("PROJECT_VISITED");
export const projectUpdatedAction = createAction<ProjectDto>("PROJECT_UPDATED");

export const addOrUpdateSaleAction =
    createAction<SaleDto>("ADD_OR_UPDATE_SALE");
export const addOrUpdateSaleActivityAction = createAction<SaleActivityDto>(
    "ADD_OR_UPDATE_ACTIVITY"
);
export const deleteSaleAction = createAction<number>("DELETE_SALE");
export const deleteActivityAction = createAction<number>(
    "DELETE_SALE_ACTIVITY"
);
export const addOrUpdateNoteAction =
    createAction<NoteDto>("ADD_OR_UPDATE_NOTE");
export const deleteNoteAction = createAction<number>("DELETE_NOTE");

export const addOrUpdateFolderAction = createAction<FolderDto>(
    "ADD_OR_UPDATE_FOLDER"
);
export const deleteFolderAction = createAction<number>("DELETE_FOLDER");
